var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-profile-menu-layout',[_c('notification-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }